import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import EventPortals from './Index.vue';
import EventPortalEditor from './Editor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/planning/event-portals'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_planning_event_portals',
          meta: {
            permissions: ['administrator'],
          },
          component: EventPortals,
        },
        {
          path: ':portalId/editor',
          name: 'settings_planning_event_portal_editor',
          meta: {
            permissions: ['administrator'],
          },
          component: EventPortalEditor,
        },
      ],
    },
    // Redirect legacy paths
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/event-page-templates'
      ),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/settings/planning/event-portals`
        ),
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/event-page-templates/:templateId/editor'
      ),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/settings/planning/event-portals/${to.params.portalId}/editor`
        ),
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/customer-portals'
      ),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/settings/planning/event-portals`
        ),
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/customer-portals/:templateId/editor'
      ),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/settings/planning/event-portals/${to.params.portalId}/editor`
        ),
    },
  ],
};
